import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { EntrepreneurProspectCourse } from '@interfaces';
import { DomainDataService } from '../../../../../../services';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, domainData: DomainDataService): GridSetup<EntrepreneurProspectCourse> {

	return {
		rowName: { singular: 'Course', plural: 'Courses' },
		getRowKey: row => '' + row.courseEnrollmentId,
		stateKey: 'entrepreneur-prospect-dialog-courses-grid',
		actions: getActions(),
		buttons: getButtons(),
		columns: getColumns(util, domainData),
		// renderRowClasses: row => row.status == 'Active' ? [] : ['grid-cell-strikethrough', 'grid-cell-gray-text'],
	}
}
